import React from 'react';

import Tooltip from 'react-tooltip-lite';

import TextArea from './TextArea';
import DeleteMessage from '../DeleteMessage';

import getPublishTime from '../../services/getPublishTime';

import I18n from '../../locales/i18n';

function ForumItem(props) {
	const {
		author_name,
		photoURL,
		likes,
		date,
		dislikes,
		message,
		answers,
	} = props.post;

	const [reactionState, setReactionState] = React.useState(null),
		[itemLikes, setItemLikes] = React.useState(likes),
		[itemDislikes, setItemDislikes] = React.useState(dislikes);

	const onReactionClick = (reaction) => {
		let currentLikes = itemLikes,
			currentDislikes = itemDislikes;

		if (reaction !== reactionState) {
			if (reactionState === null && reaction === 'like') {
				currentLikes++;
				setItemLikes(itemLikes + 1);
			}

			if (reactionState === 'dislike' && reaction === 'like') {
				currentLikes++;
				currentDislikes--;
				setItemLikes(itemLikes + 1);
				setItemDislikes(itemDislikes - 1);
			}

			if (reactionState === null && reaction === 'dislike') {
				currentDislikes++;
				setItemDislikes(itemDislikes + 1);
			}

			if (reactionState === 'like' && reaction === 'dislike') {
				currentLikes--;
				currentDislikes++;
				setItemDislikes(itemDislikes + 1);
				setItemLikes(itemLikes - 1);
			}

			setReactionState(reaction);
		} else {
			setReactionState(null);

			if (reaction === 'like') {
				currentLikes--;
				setItemLikes(itemLikes - 1);
			}

			if (reaction === 'dislike') {
				currentDislikes--;
				setItemDislikes(itemDislikes - 1);
			}
		}
		props.onReaction(currentLikes, currentDislikes, props.index);
	};

	const isOwner = props.owner === props.user_id;

	return (
		<div className="Forum__item">
			<div className="Forum__item_header">
				<DeleteMessage
					deleteLoading={props.deleteLoading}
					isOwner={isOwner}
					onClick={props.onDeletePost}
					postIdx={props.index}
				/>
				<img
					src={photoURL}
					alt="Avatar"
					className="Forum__item_header_avatar"
				/>
				<span className="Forum__item_header_author">{author_name}</span>
				<div className="Forum__item_Reactions hide">
					<span
						onClick={() => {
							onReactionClick('like');
						}}
						className={reactionState === 'like' ? 'selected' : ''}
					>
						<Tooltip content="Te gusta" direction="bottom">
							<i className="fas fa-thumbs-up"></i> {countReactions(itemLikes)}
						</Tooltip>
					</span>
					<span
						onClick={() => {
							onReactionClick('dislike');
						}}
						className={reactionState === 'dislike' ? 'selected' : ''}
					>
						<Tooltip content="No te gusta" direction="bottom">
							<i className="fas fa-thumbs-down"></i>{' '}
							{countReactions(itemDislikes)}
						</Tooltip>
					</span>
				</div>
				<span className="Forum__item_header_time">
					<Tooltip content={date} direction="left">
						{getPublishTime(date)}
					</Tooltip>
				</span>
			</div>
			<div className="Forum__item_body">{message}</div>
			<div className="Forum__item_answers">
				{answers.map((answer, idx) => {
					return (
						<div className="Forum__item_answer" key={idx}>
							<div className="Forum__item_answer_title">
								<span className="Forum__item_answer_line"></span>
								<DeleteMessage
									deleteLoading={props.deleteLoading}
									isOwner={isOwner}
									onClick={props.onDeleteAnswer}
									postIdx={props.index}
									idx={idx}
								/>
								<img
									src={answer.photoURL}
									alt="Avatar"
									className="Forum__item_header_avatar"
								/>
								<span
									className="Forum__item_header_author Forum__item_answer_author"
									title={answer.author_name}
								>
									{answer.author_name}
								</span>
								<Tooltip content={answer.date} direction="left">
									<span className="Forum__item_header_time">
										{getPublishTime(answer.date)}
									</span>
								</Tooltip>
							</div>
							<div className="Forum__item_body Forum__answer_body">
								{answer.message}
							</div>
						</div>
					);
				})}
			</div>
			{isOwner && (
				<div className="Forum__answer_answer">
					<TextArea
						onSend={(text) => {
							props.onNewAnswer(text, props.index);
						}}
						placeholder={I18n('CHAT', 'WRITE_YOUR_ANSWER')}
						photoURL={props.photoURL}
					/>
				</div>
			)}
		</div>
	);
}

export default ForumItem;

const countReactions = (count) => {
	count = parseInt(count, 10);

	if (count < 1000) return count;
	if (count < 1000000) return (count / 1000).toFixed(1) + ' K';
	return (count / 1000000).toFixed(1) + ' M';
};
